module.exports = __webpack_public_path__ + "static/img/wal.1766c8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/wal.jpg
// module id = jURH
// module chunks = 0